// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanEditWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFloorPlanEditActiveResponseWebDto,
  UserPropertyFloorPlanEditDateAvailableResponseWebDto,
  UserPropertyFloorPlanEditHighPriceResponseWebDto,
  UserPropertyFloorPlanEditLowPriceResponseWebDto,
  UserPropertyFloorPlanEditNameResponseWebDto,
  UserPropertyFloorPlanEditNumBathroomsResponseWebDto,
  UserPropertyFloorPlanEditNumBedroomsResponseWebDto,
  UserPropertyFloorPlanEditPriceResponseWebDto,
  UserPropertyFloorPlanEditSquareFeetResponseWebDto,
} from '../..';

interface ActiveParams {
  active?: boolean;
  floorPlanId: string;
}
interface DateAvailableParams {
  dateAvailable?: string;
  floorPlanId: string;
}
interface HighPriceParams {
  floorPlanId: string;
  highPrice?: number;
}
interface LowPriceParams {
  floorPlanId: string;
  lowPrice?: number;
}
interface NameParams {
  floorPlanId: string;
  name?: string;
}
interface NumBathroomsParams {
  floorPlanId: string;
  numBathrooms?: number;
}
interface NumBedroomsParams {
  floorPlanId: string;
  numBedrooms?: number;
}
interface PriceParams {
  floorPlanId: string;
  price?: string;
}
interface SquareFeetParams {
  floorPlanId: string;
  squareFeet?: number;
}

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Path =
  '/api/web/v1/users/properties/floorPlans/active';

/**
 * Update activeness of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_active = (
  getParams: ActiveParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ActiveParams, never, UserPropertyFloorPlanEditActiveResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Path =
  '/api/web/v1/users/properties/floorPlans/dateAvailable';

/**
 * Update date available of a floor plan, yyyy-MM-dd
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable = (
  getParams: DateAvailableParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DateAvailableParams, never, UserPropertyFloorPlanEditDateAvailableResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Path =
  '/api/web/v1/users/properties/floorPlans/highPrice';

/**
 * Update the highest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice = (
  getParams: HighPriceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HighPriceParams, never, UserPropertyFloorPlanEditHighPriceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Path =
  '/api/web/v1/users/properties/floorPlans/lowPrice';

/**
 * Update the lowest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice = (
  getParams: LowPriceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LowPriceParams, never, UserPropertyFloorPlanEditLowPriceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Path =
  '/api/web/v1/users/properties/floorPlans/name';

/**
 * Update name of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_name = (
  getParams: NameParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<NameParams, never, UserPropertyFloorPlanEditNameResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Path =
  '/api/web/v1/users/properties/floorPlans/numBathrooms';

/**
 * Update number of bathrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms = (
  getParams: NumBathroomsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<NumBathroomsParams, never, UserPropertyFloorPlanEditNumBathroomsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Path =
  '/api/web/v1/users/properties/floorPlans/numBedrooms';

/**
 * Update number of bedrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms = (
  getParams: NumBedroomsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<NumBedroomsParams, never, UserPropertyFloorPlanEditNumBedroomsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Path =
  '/api/web/v1/users/properties/floorPlans/price';

/**
 * Update price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_price = (
  getParams: PriceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PriceParams, never, UserPropertyFloorPlanEditPriceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Path =
  '/api/web/v1/users/properties/floorPlans/squareFeet';

/**
 * Update square feet of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet = (
  getParams: SquareFeetParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SquareFeetParams, never, UserPropertyFloorPlanEditSquareFeetResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
